<template>
  <div class="tw-w-full tw-mb-5 md:tw-mb-8">
    <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2">
      <slot />
    </div>
  </div>
</template>
